import React, {useEffect} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {isEmpty as _isEmpty} from 'lodash';

import HeaderRenderer from '@appComponents/HeaderRenderer';
import {FilterQueryWrapper, FilterUrlParamsWrapper} from '@appComponents/HOCFiltersQueryWrapper';
import {getSearchFilters} from '@utils/filters';
import {GetSpiideoStadiumMappingsForTable} from '@graphql/spiideoStadiumMapping/query';
import useQueryCustom from '@utils/hooks/useQueryCustom';
import navigation from '@constants/navigation';
import mapModulesToProps from '@utils/mapModulesToProps';
import {showErrorModal} from '@utils/modal';
import {getLink} from '@appComponents/Link';

import {exportExcel} from '../utils/export/spiideoVenuesIndexExcel';
import SpiideoVenuesFilters from '../components/SpiideoVenuesFilters';
import SpiideoVenuesIndexButtons from '../components/SpiideoVenuesIndexButtons';
import SpiideoVenuesTable from '../components/SpiideoVenuesTable';

export const DEFAULT_FILTERS_VALUES = {
    search: null,
};

export function SpiideoVenuesIndex(props) {
    const {Menu, filters} = props;

    const {
        loading,
        data: {spiideoStadiumMappings = []} = {},
        error,
    } = useQueryCustom({
        query: GetSpiideoStadiumMappingsForTable,
        options: {
            variables: {
                search: filters.search ? filters.search : DEFAULT_FILTERS_VALUES.search,
            },
            refetch: filters.lastClickSubmit,
        },
        fetchPolicy: 'no-cache',
    });

    useEffect(() => {
        if (!_isEmpty(error)) {
            showErrorModal({
                header: 'Error',
                redirectLink: getLink('spiideoMappings.venues'),
                text: 'There was an error while fetching the data.',
                errorButtonIcon: 'arrow circle left',
                errorButtonText: 'Back to list',
            });
        }
    }, [error]);

    useEffect(() => {
        Menu.storeMenu(navigation.infrastructure.key);
    }, []);

    return (
        <div>
            <HeaderRenderer
                messagesBoxNames='spiideoVenueMappingMessage'
                buttons={SpiideoVenuesIndexButtons}
                exportExcelParams={exportExcel(spiideoStadiumMappings)}
                filters={SpiideoVenuesFilters}
                filtersButtonName='SpiideoVenues'
                loading={loading && _isEmpty(error)}
            />
            <div className='table-container'>
                <SpiideoVenuesTable
                    data={spiideoStadiumMappings}
                    loading={loading}
                />
            </div>
        </div>
    );
}

SpiideoVenuesIndex.propTypes = {
    filters: PropTypes.object.isRequired,
    Menu: PropTypes.object,
};

SpiideoVenuesIndex.displayName = 'SpiideoVenuesIndex';

const SpiideoVenuesFilterWrapped = FilterQueryWrapper(SpiideoVenuesIndex, {
    queryForRefresh: 'GetSpiideoStadiumMappingsForTable',
    filterUrls: ['spiideoMappings.venues'],
});

const mapStateToProps = (state) => ({
    filters: getSearchFilters(state, 'SpiideoVenues', {...DEFAULT_FILTERS_VALUES}),
});

export default connect(mapStateToProps, mapModulesToProps(['Menu']))(FilterUrlParamsWrapper(SpiideoVenuesFilterWrapped, {...DEFAULT_FILTERS_VALUES}));
